import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
const features = [{
  title: 'Versatile Treatment',
  description: "ClearSilk isn't just for pigmentation lesions; it also tackles wrinkles, age lines, skin dullness, uneven texture, and acne scarring. Its versatility makes it a favored choice among aestheticians and individuals seeking comprehensive skin rejuvenation."
}, {
  title: 'Numerous Advantages',
  description: 'ClearSilk offers considerable benefits, notably its lack of downtime. Following a session, individuals can promptly return to their regular activities. Unlike other laser facials, this treatment is not seasonal-dependent, making it equally effective year-round.'
}, {
  title: 'Suitable for All Skin Types',
  description: "ClearSilk is suitable for all skin tones and textures, debunking the myth that laser treatments are limited by skin type. Regardless of your skin's characteristics, you can benefit from ClearSilk's effects."
}, {
  title: 'Minimal Downtime',
  description: 'Unlike ablative procedures, ClearSilk requires minimal downtime. Patients may experience some redness and warmth at the treated site, which typically resolves within 24 hours. This convenience makes ClearSilk an attractive option for those with busy schedules.'
}];
export function CSStandOut() {
  return <section className="bg-[#ECECEC] py-[60px] lg:py-[100px]" data-id="element-617">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8" data-id="element-618">
        <AnimateOnScroll className="text-center flex flex-col items-center" data-id="element-619">
          <h2 className="text-[26px] lg:text-[40px] uppercase text-black leading-tight mb-6 font-[600] font-[Poppins,_sans-serif]" data-id="element-620">
            WHAT MAKES IT A STAND OUT LASER
          </h2>

          <div className="w-[40px] h-[2px] bg-[#FF1493] mb-8" data-id="element-621"></div>

          <p className="text-[#333333] text-[17px] leading-[1.7] font-body max-w-[800px] mb-12" data-id="element-622">
            Rejuvenating your skin and regaining confidence can be a challenge,
            especially as signs of aging become more pronounced. However,
            ClearSilk laser treatment offers a multifaceted solution that
            addresses various concerns effectively and conveniently. Here's how
            ClearSilk works and why it's gaining popularity:
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 w-full max-w-[900px]" data-id="element-623">
            {features.map((feature, index) => <AnimateOnScroll key={index} delay={index * 100} className="h-full" data-id="element-624">
                <div className="bg-white p-8 shadow-[0_4px_16px_rgba(0,0,0,0.08)] border-t-[3px] border-[#FF1493] text-left h-full flex flex-col" data-id="element-625">
                  <h3 className="text-[20px] font-bold text-black mb-4 font-[Poppins,_sans-serif]" data-id="element-626">
                    {feature.title}
                  </h3>
                  <p className="text-[#333333] text-[15px] leading-[1.6] font-body" data-id="element-627">
                    {feature.description}
                  </p>
                </div>
              </AnimateOnScroll>)}
          </div>
        </AnimateOnScroll>
      </div>
    </section>;
}